export default __webpack_public_path__ + "static/media/Ensaladas.d90edd1d.jpg";